module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/2/2-4d88f9be4d93df08616394b7a2eb3bfe.jpg";